const INDEX_ITEMS = [
  { id: 1, title: '明星恋情实锤追踪', desc: '最新明星恋情爆料与实锤整理', icon: 'ri-heart-pulse-line', color: 'text-primary-500', bg: 'bg-primary-50' },
  { id: 2, title: '网红人设崩塌现场', desc: '头部网红翻车事件全记录', icon: 'ri-ghost-line', color: 'text-accent-500', bg: 'bg-accent-50' },
  { id: 3, title: '综艺节目幕后真相', desc: '热门综艺内幕与未播出片段', icon: 'ri-tv-2-line', color: 'text-primary-500', bg: 'bg-primary-50' },
  { id: 4, title: '直播圈大事件', desc: '直播平台主播动态与争议', icon: 'ri-live-line', color: 'text-accent-500', bg: 'bg-accent-50' },
  { id: 5, title: '娱乐圈深度揭秘', desc: '行业内幕、潜规则与爆料', icon: 'ri-spy-line', color: 'text-primary-500', bg: 'bg-primary-50' },
  { id: 6, title: '体育圈八卦汇', desc: '体育明星场外花边新闻', icon: 'ri-basketball-line', color: 'text-accent-500', bg: 'bg-accent-50' },
  { id: 7, title: '电竞圈吃瓜专区', desc: '电竞选手与俱乐部动态追踪', icon: 'ri-gamepad-line', color: 'text-primary-500', bg: 'bg-primary-50' },
  { id: 8, title: '海外娱乐圈', desc: '日韩欧美娱乐圈一手资讯', icon: 'ri-global-line', color: 'text-accent-500', bg: 'bg-accent-50' },
  { id: 9, title: '每日吃瓜速递', desc: '每日热点快速浏览与讨论', icon: 'ri-flashlight-line', color: 'text-primary-500', bg: 'bg-primary-50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            快速导航
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            吃瓜索引
          </h2>
          <p className="text-sm text-foreground-500 mt-3">按分类浏览，找到你想吃的瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {INDEX_ITEMS.map((item) => (
            <div
              key={item.id}
              className="group flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${item.bg} flex-shrink-0`}>
                <i className={`${item.icon} ${item.color} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-400 transition-colors flex-shrink-0 mt-1"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}